import React, { useState } from "react";
import Model from "../modal";
import { privacy, tc } from "./privacy";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);

  return (
    <div className="h-12 ">
      {showModal && (
        <Model
          toggleModal={() => {
            setShowModal(false);
          }}
          showModal={showModal}
          tittle={
            modalType == "privacy" ? "Privacy Policy" : "Terms & Conditions"
          }
        >
          <div className="scrolling-auto">
            <p className="h-auto">
              <pre>{modalType == "privacy" ? privacy : tc}</pre>
            </p>
          </div>
        </Model>
      )}
      <hr className="bg-black " />
      <div className="flex justify-center py-5 ">
        <div className="p-2 inline">© {new Date().getFullYear()}</div>
        <div
          onClick={() => {
            setShowModal(true);
            setModalType("tc");
          }}
          className="p-2 underline"
        >
          Terms
        </div>
        <div
          onClick={() => {
            setShowModal(true);
            setModalType("privacy");
          }}
          className="p-2 underline"
        >
          Privacy
        </div>
      </div>
    </div>
  );
};

export default Footer;
